import { RELATIONSHIP_REGISTRY } from "../../config/relationshipRegistry";

export const SECTION_CATALOG = Object.fromEntries(
  Object.entries(RELATIONSHIP_REGISTRY).map(([entityType, sections]) => [
    entityType,
    sections.map((section) => {
      const rest = { ...section };
      delete rest.order;
      return rest;
    }),
  ])
);
